import React from "react";
import ApplyNowButton from "../../../../../components/applynowbutton";

const OutcomesEJ = () => {
  return (
    <div
      className=" py-10 mt-5 rounded-lg bg-gray-900 text-white relative"
      id="outcomes"
    >
      <div className="absolute inset-0 bg-black bg-opacity-50 z-10 rounded-lg"></div>
      <div className="h-full flex items-center justify-center relative z-20 px-10 text-center">
        <div className="max-w-4xl">
          <h2 className="md:text-3xl text-lg font-bold mb-4">
            Postgraduate Certificate/Diploma Option
          </h2>
          <div className="bg-sdorange h-1 w-10 mx-auto mb-4"></div>

          <p className="md:text-lg text-base leading-relaxed text-justify">
            Looking to further enhance your credentials in creative leadership &
            entrepreneurship? The Emerging Journalist Programme can be taken as
            part of our Postgraduate Certificate (30 credits) or Diploma (60
            credits) in Creative Leadership & Entrepreneurship. This extended
            pathway offers a comprehensive framework for aspiring media leaders
            to develop advanced skills & insights, positioning themselves for
            success in the dynamic landscape of media & innovation.
          </p>
        </div>
      </div>
      <div
        className="absolute inset-0 bg-cover bg-center rounded-lg"
        style={{ backgroundImage: "url('/image-fix/random-images/r4.jpg')" }}
      ></div>
      <ApplyNowButton />
    </div>
  );
};

export default OutcomesEJ;
